import checkAISource from 'assets/check-ai-logo.svg';
import styled, { css } from 'styled-components';

export const IconWrapper = styled.div`
  ${({ theme }) => css`
    color: ${theme.color.icon.neutral.default};
  `}
`;

export const CheckAILogo = styled.img.attrs({ src: checkAISource, alt: 'check-ai-logo' })`
  width: 95px;
`;
